module.exports = __webpack_public_path__ + "img/243.4a1d78f7.jpg";